// Module
var code = `<ul>
  {{#state}}
  <li class="menu-list-item-{{num}}">
    <button
      class="code-playground-btn-{{num}}-{{sectionNum}}"
      data-button-type="codePlayground"
      data-num="{{num}}"
      data-prev-num="{{num}}"
      data-section-num="{{sectionNum}}"
      data-code-block-data-section="{{codeBlockDataSection}}"
      data-code-block-state-name="{{name}}"
      data-code-block-id="{{codeBlockId}}"
      data-method-name="{{methodName}}"
      data-type-id="{{type}}"
      data-type="{{type}}"
      data-state="{{name}}"
      data-example-id="{{name}}"
    >
      {{menuTitle}}
    </button>
  </li>
  {{/state}}
</ul>
`;
// Exports
module.exports = code;